import '@style/common/main-style'

import '@style/common/breadcrumbs.css'

import './index.css'

import { deletePage } from '@utils/browserTest.ts'
import { generateLegalsElements } from '@core/views/legals/generate.ts'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(() => {
    if (import.meta.env.DEV) {
      generateLegalsElements(document)
    }

    removeCurrentPageClickEvent()
  })
})
